import { applyMiddleware, compose, createStore } from "redux";

import { loadState, saveState } from "./localStorage";

import { createLogger } from "redux-logger";
import { thunk } from "redux-thunk";
import appReducer from "./redux/index";
const persistedState = loadState();

const enhancers = [];
const loggerMiddleware = createLogger();

const middleware = [thunk, loggerMiddleware];

export const store = createStore(
  appReducer,
  persistedState,
  compose(applyMiddleware(...middleware), ...enhancers)
);
 /* istanbul ignore next */
store.subscribe(() => {
  saveState({
    ekyc: store.getState().ekyc,
  });
});
